import Jt808SetOverSpeedDurationModal from './jt808-set-over-speed-duration-modal.vue'
export default Jt808SetOverSpeedDurationModal
